import {Address} from "./Store";

export class PearlsPlanningEntry {

  public static fromJson(json: Object): PearlsPlanningEntry {
    let pearlsPlanning: PearlsPlanningEntry = new PearlsPlanningEntry();

    pearlsPlanning.planningEntryType = json['planningEntryType'];

    pearlsPlanning.ctxId = json['ctxId'];
    pearlsPlanning.id = json['id'];
    pearlsPlanning.logaDay = json['logaDay'];
    pearlsPlanning.areaId = json['areaId'];
    pearlsPlanning.areaName = json['areaName'];
    pearlsPlanning.sectorId = json['sectorId'];
    pearlsPlanning.sectorName = json['sectorName'];
    pearlsPlanning.storeId = json['storeId'];
    pearlsPlanning.storeName = json['storeName'];
    pearlsPlanning.salesRepId = json['salesRepId'];
    pearlsPlanning.salesRepName = json['salesRepName'];
    pearlsPlanning.status = json['status'];
    pearlsPlanning.statusClass = json['statusClass'];
    pearlsPlanning.nbPictures = json['nbPictures'];
    pearlsPlanning.retailerName = json['retailerName'];
    pearlsPlanning.startTime = json['startTime'];
    pearlsPlanning.endTime = json['endTime'];
    pearlsPlanning.retailerIconUrl = json['retailerIconUrl'];
    pearlsPlanning.address = json['address'];
    pearlsPlanning.checkInDone = json['checkInDone'];
    pearlsPlanning.hrDuration = json['hrDuration'];
    pearlsPlanning.description = json['description'];
    pearlsPlanning.objectives = [];

    let objectives = json['objectives']
    if (objectives)
      objectives.forEach(oobj => pearlsPlanning.objectives.push(Objective.fromJson(oobj)));


    return pearlsPlanning;
  }

  planningEntryType: string;

  // pearls context id
  ctxId: number;
  // storecheck or event Id
  id: number;

  logaDay: number;
  areaId: number;
  areaName: string;
  sectorId: number;
  sectorName: string;

  storeId: number;
  storeName: string;
  description: string;

  salesRepId: number;
  salesRepName: string

  startTime: string;
  endTime: string;

  status: string;
  statusClass: string;

  retailerName: string;
  retailerIconUrl: string;
  nbPictures: number;

  objectives: Objective[];

  address: Address;
  checkInDone: boolean;
  hrDuration: string;

  /**
   * utitility flag to show/hide content with simple filtering
   */
  public uiShouldHide: boolean;

  toHrStatus(): string {
    if (this.status == null) return "";
    else if (this.status === 'EMPTY')
      return "Affecté";
    else if (this.status === 'COMPLETE')
      return "Réalisé";
    else if (this.status === 'WIP')
      return "En cours";
    else return "";
  }
}


export class Objective {
  public id: number;
  public code: string;
  public name: string;
  public fulfilled: boolean;

  static fromJson(o: Objective) {
    let obj: Objective = new Objective();
    obj.id = o.id;
    obj.name = o.name;
    obj.code = o.code;
    obj.fulfilled = o.fulfilled;
    return obj;
  }
}




// WEBPACK FOOTER //
// ./src/model/PearlsPlanning.ts